export default __webpack_public_path__ + "static/media/footer-bg.1e3d0b93.png";